import { OnInit, Component, Output, EventEmitter } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
@Component({
    selector: "mileage-location-info-panel",
    templateUrl: "./mileage-location-info-panel.component.html",
    standalone: true,
    imports: [TranslateModule]
})
export class MileageLocationInfoPanelComponent implements OnInit {
  @Output() closePanelEvent = new EventEmitter<boolean>();
  
  constructor() {
  }

  ngOnInit() {
  }
  
  closePanel(){
    this.closePanelEvent.emit(true);
  }
}
